import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {LabsComponent} from './labs/labs.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {TaskComponent} from './labs/task/task.component';


const routes: Routes = [
  // {path:"/",component:HomeComponent},
  // {path:"/labs",component:LabsComponent}
  { path: '', component: HomeComponent},
  {
    path: 'labs/:id',
    component: LabsComponent,
    children:[
      {
        path:'tasks/:id',
        component:TaskComponent
      }
    ]
  },
  { path: '**', component: PageNotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
